// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__ld6tU","approved":"Status_approved__1nwzL","rejected":"Status_rejected__dt57S","expired":"Status_expired__25-8l","label":"Status_label__1_sZj"};